import { Entities } from "../entities"
import { NameAttributes, Paymethods, ProductCategoryEntity, ReferenceType, ValueType } from "../products/product"

export default interface OrdersEntity {
    _id: string
    code: string
    coupon: Partial<CouponsEntity>
    bill: OrderFileEntity
    status: OrderStatus
    shipping_info: ShippingInfo
    refunded?: OrderRefunded
    products: OrderProductsEntity[]
    denial?: OrderDenialEntity
    _created?: Date
}

interface CouponsEntity {
    _id?: string,
    code?: string,
    type: TypesCoupon
    discount?: number,
    amount?: number,
    expiration: Date,
    _created?: Date,
    _modified?: Date,
    _deleted?: boolean
}

export enum TypesCoupon {
    AMOUNT = 'amount',
    DISCOUNT = 'discount'
}

export enum OrderStatus {
    new = 'new',
    pending = 'pending',
    processing = 'processing',
    on_the_way = 'on_the_way',
    rejected = 'rejected',
    delivered = 'delivered',
    refunded = 'refunded',
}

interface OrderFileEntity {
    _id: string
    url: string
}

export interface ShippingInfo {
    company: string | null
    company_address: string | null
    code: string | null
    date: Date | null
    estimated_date: number | null
    evidenced: OrderFileEntity
    type: ShippingType | null
    price: number | null
}

export enum ShippingType {
    payed = 'payed',
    payment_on_delivery = 'payment_on_delivery',
}

interface OrderRefunded {
    reason: string
}

export interface OrderDenialEntity {
    reason: string
}

export interface OrderProductsEntity {
    _id?: string
    type: Entities
    category: ProductCategoryEntity
    shipping_info: ShippingInfoProductsOrder
    name: string
    description: string
    discount: number
    brand: string

    totalQuantity: number
    subtotal: number
    totalDiscount: number
    totalShipping: number
    total: number

    productDiscount: number
    couponDiscount: number

    attributes?: OrderAttributeProductsEntity[]
    _created?: Date
}

export interface OrderAttributeProductsEntity {
    _id?: string
    name: NameAttributes[]
    type: Entities
    value: ValueType[]
    reference: ReferenceType[]
    quantity: number

    price: number
    subtotal: number
    productDiscount: number
    couponDiscount: number
    discount: number
    total: number

    image?: ImagesEntity
    _created?: Date
}

export interface ImagesEntity {
    _id?: string
    url: string
    _created?: Date
    _modified?: Date
    _deleted?: boolean
}

export interface ShippingInfoProductsOrder {
    isHaveShipping: boolean
    type: Paymethods
    price: number
}
